module.exports = __webpack_public_path__ + "static/media/day_lake.c26c862e.jpg";